import axios from 'axios'

// Só a ÚLTIMA página pedida vale: trocar de página/tamanho rápido deixava a resposta mais lenta (e antiga) vencer.
let loadJobsController = null

// Opções do passo "executar outra automação" (até 2000 jobs, { id, label }): cache com TTL e requisição em voo única
export const JOB_OPTIONS_TTL_MS = 5 * 60 * 1000
let jobOptionsInFlight = null

const moduleJob = {
  state: () => ({
    jobs: {
      data: [],
      total: 0
    },
    options: {
      items: [],
      at: 0
    }
  }),
  getters: {
    getJobs: (state) => state.jobs
  },
  mutations: {
    SET_JOBS (state, { jobs, total }) {
      state.jobs.data = jobs
      state.jobs.total = total
    },
    SET_JOB_OPTIONS (state, { items, at }) {
      state.options = { items, at }
    },
    CLEAR_JOB_OPTIONS (state) {
      state.options = { items: [], at: 0 }
    },
    DELETE_JOB (state, id) {
      const index = state.jobs.data.findIndex((job) => job.jobId === id)
      if (index > -1) {
        state.jobs.data.splice(index, 1)
        state.jobs.total--
      }

      // a opção do job excluído também sai da lista do passo "executar outra automação"
      state.options = { items: state.options.items.filter((item) => item.id !== id), at: state.options.at }
    }
  },
  actions: {
    /** Resolve `{ cancelled: true }` quando uma chamada mais nova tomou o lugar desta (aí nada foi gravado na store). */
    async loadJobs ({ getters, commit }, { page, fetch }) {
      if (loadJobsController) loadJobsController.abort()

      const controller = new AbortController()
      loadJobsController = controller

      try {
        const { data } = await axios.get(
          `${getters.api}/job?page=${page}&fetch=${fetch}`,
          { signal: controller.signal }
        )

        commit('SET_JOBS', { jobs: data.itens, total: data.totalResults })

        return { cancelled: false }
      } catch (e) {
        if (axios.isCancel(e) || e.code === 'ERR_CANCELED') return { cancelled: true }

        throw e
      } finally {
        if (loadJobsController === controller) loadJobsController = null
      }
    },

    async loadJobOptions ({ state, getters, commit }, { force = false } = {}) {
      if (!force && state.options.at && Date.now() - state.options.at < JOB_OPTIONS_TTL_MS) {
        return state.options.items
      }

      if (jobOptionsInFlight) return jobOptionsInFlight

      const request = axios
        .get(`${getters.api}/job?fetch=2000`)
        .then(({ data }) => {
          const items = data.itens.map((item) => ({ id: item.jobId, label: item.name }))

          commit('SET_JOB_OPTIONS', { items, at: Date.now() })

          return items
        })
        .finally(() => {
          if (jobOptionsInFlight === request) jobOptionsInFlight = null
        })

      jobOptionsInFlight = request

      return request
    },

    async deleteJob ({ getters, commit }, id) {
      await axios
        .delete(`${getters.api}/job/${id}`)
        .then(() => {
          commit('DELETE_JOB', id)
        })
        .catch((e) => {
          throw e
        })
    }
  }
}

export default moduleJob
